import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right-heavy",
  "use": "icon-chevron-right-heavy-usage",
  "viewBox": "0 0 7 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 7 12\" id=\"icon-chevron-right-heavy\">\r\n<path d=\"M1,12c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4L4.6,6L0.3,1.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l5,5\r\n\tc0.4,0.4,0.4,1,0,1.4l-5,5C1.5,11.9,1.3,12,1,12z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol